module.exports = __webpack_public_path__ + "img/GS_Profile-Jamie Lee Dyers.891d9e6c.png";